import { ApplicationRegistry } from './registry';
import { notesManifest } from './notes/NotesApp';
import { filesManifest } from './files/FilesApp';
import { terminalManifest } from './terminal/TerminalApp';
import { inspectorManifest } from './inspector/InspectorApp';
import { analyticsManifest } from './analytics/AnalyticsApp';

export type {
  ApplicationApi,
  ApplicationCapabilities,
  ApplicationCategory,
  ApplicationManifest,
  ApplicationProps,
  DefaultPosition,
} from './types';
export { DEFAULT_CAPABILITIES } from './types';
export { ApplicationRegistry } from './registry';

export const createDefaultRegistry = (): ApplicationRegistry => {
  const registry = new ApplicationRegistry();
  for (const manifest of [notesManifest, filesManifest, terminalManifest, inspectorManifest, analyticsManifest])
    registry.register(manifest);
  return registry;
};
